































































import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import Competence from '@/competences/entities/competence'

@Component
export default class CompetenceForm extends Vue {
  @Prop()
  private value!: Competence

  @Prop({ type: Boolean, default: false })
  private hideRating!: boolean

  @Prop({ type: Boolean, default: false })
  private hideTemplateOptions!: boolean

  private model = this.value

  @Watch('value')
  private valueUpdated(val: Competence, old: Competence) {
    this.model = val
  }

  private setGlobal(isTemplate: boolean) {
    if (this.model.isGlobal && isTemplate === false) {
      this.model.isGlobal = false
    }
  }
}
